import Controller from 'controllers/controller';
import Elements from 'tools/elements';
import Binder from 'tools/binder';

class ContactController extends Controller {
    constructor(app) {
        super(app);
        
        this.elements = new Elements;
        this.binder = new Binder(this);
        
        this.app.loaderController.on('contact-loaded', () => {
            this.loadGoogleMaps();
            
            // if (MAP_READY) {
            //     this.init();
            // }
        });
    }
    
    loadGoogleMaps() {
        let script = document.createElement('script');

        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAs53x-GlPhOCt3FgmE8iKgkxadxKJZQPg&callback=mapReady';
        script.async = true;
        script.defer = true;

        document.body.appendChild(script);
    }

    init() {
        this.cacheElements();
        this.removeEvents();
        this.attachEvents();
        this.initMap();
    }
    
    cacheElements() {
        this.elements.queryOne('page', '.page[data-template="contact"]');
        this.elements.queryOne('map', '.map-container', 'page');
        this.elements.queryOne('impressum', '.impressum-trigger', 'page');
    }
    
    attachEvents() {
        if (this.elements.has('impressum')) {
            this.elements.get('impressum').addEventListener('click', this.binder.bind('onImpressumClick'));
        }
    }
    
    removeEvents() {
        if (this.elements.has('impressum')) {
            this.elements.get('impressum').removeEventListener('click', this.binder.bind('onImpressumClick'));
        }
    }

    onImpressumClick(event) {
        event.preventDefault();
        
        this.app.modalsController.openModal('impressum');
    }

    initMap() {
        let mapElement = this.elements.get('map');
        
        // If map element doesn't exist, then for some reason it's not in the dom yet, try again
        if ( ! mapElement) {
            setTimeout(() => this.initMap(), 1000);
            
            return;
        }
        
        this.map = new google.maps.Map(mapElement, {
            center: {lat: 48.129808, lng: 11.592661},
            zoom: 15
        });
        
        let marker = new google.maps.Marker({
            position: {lat: 48.129808, lng: 11.592661},
            map: this.map,
            icon: {
                url: APP_ROOT + 'site/templates/images/map-marker.png',
                size: new google.maps.Size(84, 128),
                scaledSize: new google.maps.Size(42, 64),
                anchor: new google.maps.Point(21, 64)
            }
        });
    }
}

export default ContactController;